import React, { useState } from 'react'
import _ from 'lodash'
import api from '../api'

let NewUserEditor = ({
  partnerId,
  partnerClientIds,
  onClose,
  onSavedNewUser,
}) => {
  let [name, setName] = useState('')
  let [email, setEmail] = useState('')
  let [phoneNumber, setPhone] = useState('')
  let [errorText, setErrorText] = useState('')
  let [password, setPassword] = useState('')
  let [saving, setSaving] = useState(false)

  return (
    <div className="form-group border p-3">
      <label>Add New User</label>
      <div className="row mb-1 mx-0">
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text" style={{ minWidth: '42px' }}>
              <i className="fa fa-user" />
            </span>
          </div>
          <input
            onChange={e => setName(e.target.value)}
            className="form-control form-control-sm"
            placeholder="Name"
            value={name}
          />
        </div>
      </div>

      <div className="row mb-1 mx-0">
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text" style={{ minWidth: '42px' }}>
              <i className="fa fa-phone" />
            </span>
          </div>
          <input
            onChange={e => setPhone(e.target.value)}
            className="form-control form-control-sm"
            placeholder="Phone Number"
            value={phoneNumber}
          />
        </div>
      </div>

      <div className="row mb-1 mx-0">
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <i className="fa fa-envelope" />
            </span>
          </div>
          <input
            onChange={e => setEmail(e.target.value)}
            className="form-control form-control-sm"
            placeholder="Email"
            value={email}
          />
        </div>
      </div>

      <div className="row mx-0">
        <div className="input-group">
          <div className="input-group-prepend">
            <span className="input-group-text">
              <i className="fa fa-key" />
            </span>
          </div>
          <input
            onChange={e => setPassword(e.target.value)}
            className="form-control form-control-sm"
            placeholder="Temporary Password"
            value={password}
          />
        </div>
      </div>

      <div className="my-2">
        <button
          className="btn btn-danger btn-sm"
          onClick={onClose}
          disabled={saving}
        >
          Cancel
        </button>
        <button
          className="ml-2 btn btn-success btn-sm"
          disabled={saving || !password || !name || !email}
          onClick={async () => {
            setErrorText('')
            setSaving(true)

            try {
              let newUserId = await api('/create-new-partner-user', {
                partnerId,
                partnerClientIds,
                email,
                name,
                password,
                phoneNumber,
              })

              await onSavedNewUser({
                uid: newUserId,
                email,
                name,
                phoneNumber,
              })
            } catch (e) {
              console.log('Error creating new user', e)
              setErrorText(_.get(e, 'response.data', 'Error creating new user'))
              setSaving(false)
            }
          }}
        >
          Save New User {saving && <i className="fa fa-spinner fa-spin" />}
        </button>

        <div className="text-danger">{errorText}</div>
      </div>
    </div>
  )
}

export default NewUserEditor
